export const ECOMMERCE_B2C = 'Ecommerce B2C Bundle';
export const SURVEY = 'Survey and Raffle Bundle';
export const SHOPIFY = 'Shopify Bundle';
export const INQUIRY = 'Inquiry Bundle';
export const B2B = 'B2b Bundle';
export const STORE_MANAGEMENT = 'Mall Stores Management Bundle';
export const INSURANCE = 'Insurance Bundle';
export const DISTRIBUTOR = 'Distributor Bundle';
export const AFFILIATE = 'Affiliate Bundle';
